<script setup lang="ts">
import { SellingMethod } from '~/apiClient';

interface Props {
    sellingMethod: SellingMethod;
    size?: 'xs' | 'sm';
}
const { sellingMethod, size = 'sm' } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();

// DATA
const containerClasses = computed(() => (size === 'xs' ? 'gap-x-0.5 text-xs' : 'gap-x-1 text-sm'));
const iconClasses = computed(() => (size === 'xs' ? 'size-4' : 'size-5'));
</script>

<template>
    <p class="text-muted flex flex-row items-center" :class="containerClasses">
        <UIcon v-if="sellingMethod === SellingMethod.Auction" :class="iconClasses" name="lucide:gavel" />
        <UIcon v-else-if="sellingMethod === SellingMethod.DirectSale" :class="iconClasses" name="lucide:shopping-bag" />
        <UIcon v-else-if="sellingMethod === SellingMethod.OfflineSale" :class="iconClasses" name="lucide:handshake" />
        <UIcon v-else-if="sellingMethod === SellingMethod.DealerSale" :class="iconClasses" name="lucide:store" />
        <span>{{ tt(`sale.sellingMethod.${sellingMethod}`) }}</span>
    </p>
</template>
